import { Article, WithContext } from 'schema-dts';
import { TransformedArticlePage } from '~/transforms/transformPages';
import { GeigerLocale } from '~/utility/i18n';

/**
 * Generates Article JSON-LD schema for Geiger Gruppe articles
 * @param article Transformed article data
 * @param locale Current locale for language-specific data
 * @returns Article schema object
 */
export function generateArticleSchema(article: TransformedArticlePage, locale: GeigerLocale): WithContext<Article> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.stage?.headline?.text,
    image: article.stage?.image?.src ? [article.stage.image.src] : undefined,
    datePublished: article.stage?.date?.dateValue,
    author: {
      '@type': 'Organization',
      name: 'Geiger Gruppe',
    },
    keywords: article.tags?.map(String),
    inLanguage: locale,
    description: article.stage?.copy,
    mainEntityOfPage: article.meta?.link?.[0]?.href || undefined,
  };
}
